(()=>{
  if(window.egiftsMagnetTextCartPreviewV1) return;
  window.egiftsMagnetTextCartPreviewV1=true;

  const ROW_SELECTOR='[data-egifts-magnet-type="text_opener"]';
  const OVERLAY_CLASS='egifts-cart-opener-text-preview';
  const BOX={x:.258,y:.382,w:.443,h:.148};
  let timer=null;
  let observer=null;

  const fontMap={
    bold:{family:'"Arial Black", Arial, Helvetica, sans-serif',weight:'900'},
    kalam:{family:'"Kalam", cursive',weight:'700'},
    poetsen:{family:'"Poetsen One", Arial, sans-serif',weight:'400'},
    modern:{family:'"Trebuchet MS", Arial, sans-serif',weight:'700'}
  };

  const ensureFonts=()=>{
    if(!document.querySelector('link[data-egifts-magnet-fonts]')){
      const pre1=document.createElement('link');
      pre1.rel='preconnect';
      pre1.href='https://fonts.googleapis.com';
      pre1.dataset.egiftsMagnetFonts='1';
      document.head.appendChild(pre1);

      const pre2=document.createElement('link');
      pre2.rel='preconnect';
      pre2.href='https://fonts.gstatic.com';
      pre2.crossOrigin='anonymous';
      pre2.dataset.egiftsMagnetFonts='1';
      document.head.appendChild(pre2);

      const link=document.createElement('link');
      link.rel='stylesheet';
      link.href='https://fonts.googleapis.com/css2?family=Kalam:wght@700&family=Poetsen+One&display=swap';
      link.dataset.egiftsMagnetFonts='1';
      link.addEventListener('load',()=>schedule());
      document.head.appendChild(link);
    }

    if(!document.getElementById('egifts-cart-opener-text-style')){
      const style=document.createElement('style');
      style.id='egifts-cart-opener-text-style';
      style.textContent=`
        .${OVERLAY_CLASS}{
          position:absolute;
          z-index:8;
          display:flex;
          align-items:center;
          justify-content:center;
          overflow:hidden;
          box-sizing:border-box;
          padding:0 2px;
          color:#111;
          text-align:center;
          line-height:.92;
          pointer-events:none;
        }
        .${OVERLAY_CLASS} span{
          display:block;
          width:100%;
          height:auto;
          white-space:pre-line;
          overflow-wrap:normal;
          word-break:normal;
          text-align:center;
          line-height:.9;
          transform:translateY(1px);
        }
      `;
      document.head.appendChild(style);
    }
  };

  const cartUrl=()=>{
    const root=window.Shopify?.routes?.root||'/';
    return `${root}cart.js`.replace(/\/{2,}/g,'/');
  };

  const fetchCart=async()=>{
    try{
      const r=await fetch(cartUrl(),{
        headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
        cache:'no-store'
      });
      if(!r.ok) return null;
      return await r.json();
    }catch(e){
      return null;
    }
  };

  const getProps=(item)=>item && item.properties && typeof item.properties==='object' ? item.properties : {};

  const toTwoLines=(value)=>{
    const clean=String(value||'').replace(/\s+/g,' ').trim();
    if(!clean) return '';
    if(clean.length<=13) return clean;

    const words=clean.split(' ');
    if(words.length===1){
      const cut=Math.ceil(clean.length/2);
      return `${clean.slice(0,cut)}\n${clean.slice(cut)}`;
    }

    let bestIndex=1;
    let bestDiff=Infinity;

    for(let i=1;i<words.length;i++){
      const a=words.slice(0,i).join(' ');
      const b=words.slice(i).join(' ');
      const diff=Math.abs(a.length-b.length);
      if(diff<bestDiff){
        bestDiff=diff;
        bestIndex=i;
      }
    }

    return `${words.slice(0,bestIndex).join(' ')}\n${words.slice(bestIndex).join(' ')}`;
  };

  const fit=(el,box,max,min)=>{
    if(!el || !box) return;
    let size=Math.max(min,max);
    const maxW=Math.max(1,box.clientWidth-4);
    const maxH=Math.max(1,box.clientHeight-2);

    el.style.fontSize=`${size}px`;

    while(size>min && (el.scrollWidth>maxW || el.scrollHeight>maxH)){
      size-=.35;
      el.style.fontSize=`${size}px`;
    }
  };

  const position=(row,overlay)=>{
    const container=row.querySelector('.cart-item__image-container');
    const img=container?.querySelector('img.cart-item__image');
    if(!container || !img || !overlay) return;

    if(getComputedStyle(container).position==='static') container.style.position='relative';

    const ir=img.getBoundingClientRect();
    const cr=container.getBoundingClientRect();
    if(!ir.width || !ir.height || !cr.width || !cr.height) return;

    overlay.style.left=`${ir.left-cr.left+ir.width*BOX.x}px`;
    overlay.style.top=`${ir.top-cr.top+ir.height*BOX.y}px`;
    overlay.style.width=`${ir.width*BOX.w}px`;
    overlay.style.height=`${ir.height*BOX.h}px`;

    const span=overlay.querySelector('span');
    const mobile=window.matchMedia('(max-width: 749px)').matches;
    const maxSize=mobile ? Math.max(7.5,ir.width*.092) : Math.max(9,ir.width*.12);
    fit(span,overlay,maxSize,mobile ? 5.2 : 6.5);
  };

  const render=async()=>{
    const rows=Array.from(document.querySelectorAll(ROW_SELECTOR));
    if(!rows.length) return;

    const cart=await fetchCart();
    const byKey=new Map((cart?.items||[]).map(item=>[String(item.key||''),item]));

    rows.forEach(row=>{
      const textNode=row.querySelector('.egifts-cart-magnet-personalization__text');
      const text=(textNode?.innerText||textNode?.textContent||'').trim();
      if(!text) return;

      const container=row.querySelector('.cart-item__image-container');
      const img=container?.querySelector('img.cart-item__image');
      if(!container || !img) return;

      let overlay=container.querySelector(`.${OVERLAY_CLASS}`);
      if(!overlay){
        overlay=document.createElement('span');
        overlay.className=OVERLAY_CLASS;
        overlay.setAttribute('aria-hidden','true');
        overlay.innerHTML='<span></span>';
        container.appendChild(overlay);
      }

      overlay.querySelector('span').textContent=toTwoLines(text);

      const key=String(row.dataset.egiftsCartKey||'');
      const item=byKey.get(key);
      const props=getProps(item);
      const fontKey=String(props._egifts_font_key||'bold');
      const cfg=fontMap[fontKey]||fontMap.bold;
      const inner=overlay.querySelector('span');
      inner.style.fontFamily=cfg.family;
      inner.style.fontWeight=cfg.weight;

      const update=()=>position(row,overlay);
      if(img.complete) update();
      else img.addEventListener('load',update,{once:true});
      requestAnimationFrame(update);
    });
  };

  const schedule=()=>{
    clearTimeout(timer);
    timer=setTimeout(render,80);
  };

  const startObserver=()=>{
    observer?.disconnect();
    const target=document.querySelector('#main-cart-items')||document.querySelector('cart-items')||document.body;
    observer=new MutationObserver((mutations)=>{
      const structural=mutations.some(m=>m.addedNodes.length||m.removedNodes.length);
      if(structural) schedule();
    });
    observer.observe(target,{childList:true,subtree:true});
  };

  ensureFonts();

  const init=()=>{
    render();
    startObserver();
    window.addEventListener('resize',schedule,{passive:true});
    document.addEventListener('shopify:section:load',schedule);
    document.addEventListener('shopify-event-cart-modified',schedule);
    document.addEventListener('shopify-event-cart-ajax',schedule);
    if(document.fonts?.ready) document.fonts.ready.then(schedule).catch(()=>{});
  };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();